/* ============================================================
   Гангантогос Моторс — advertised monthly payment for product cards.

   The figure on a card is a headline, not a quote: one plan (Gangan 1 —
   30% deposit, 2.7%, 88 months), the cheapest monthly of the three. The
   real numbers are produced by the calculator on the product page and by
   the application form, and a customer who clicks through must land on
   the same figure — so the arithmetic here is deliberately identical to
   quoteFor() in sections/leasing-application.liquid.

   The same annuity currently exists in three places:
     - snippets/leasing-calculator.liquid   (calcMonthly / getMaxNper)
     - sections/leasing-application.liquid  (quoteFor / termFor)
     - here
   They have drifted before. If a rate, term or the price brackets move,
   all three have to move together. Folding the other two onto this file
   is the way out, and is worth doing.
   ============================================================ */
(function () {
  'use strict';

  /* Loaded once per page even though several sections may ask for it. */
  if (window.gmLeasingQuote) return;

  /* Term by price bracket (≤100 сая, ≤150 сая, above) for a plan whose term
     varies — Gangan 5's. Mirrors termFor() in
     sections/leasing-application.liquid. */
  function termForPrice(price) {
    if (price <= 100000000) return 72;
    if (price <= 150000000) return 84;
    return 96;
  }

  /**
   * Monthly annuity payment.
   *
   * @param {number} price      Car price in tugrik (not cents).
   * @param {object} opts
   * @param {number} opts.downPct   Deposit as a percentage of the price.
   * @param {number} opts.rateTenths Monthly rate in tenths of a percent: 25 = 2.5%.
   * @param {number} [opts.term]    Months; omitted means the price bracket decides.
   * @returns {{monthly: number, term: number, financed: number}|null}
   *          null when there is nothing sensible to show.
   */
  function gmLeasingQuote(price, opts) {
    if (!(price > 0)) return null;

    var o = opts || {};
    var downPct = isFinite(o.downPct) ? o.downPct : 30;
    var rateTenths = isFinite(o.rateTenths) ? o.rateTenths : 27;
    var term = o.term > 0 ? o.term : termForPrice(price);

    var financed = price - (price * downPct / 100);
    if (!(financed > 0) || !(term > 0)) return null;

    var r = rateTenths / 1000;
    /* A zero rate would divide by zero below; straight-line instead. */
    if (!(r > 0)) {
      return { monthly: financed / term, term: term, financed: financed };
    }

    var g = Math.pow(1 + r, term);
    return {
      monthly: financed * r * g / (g - 1),
      term: term,
      financed: financed
    };
  }

  /* "1,353,787₮" — the grouping the cards already use for prices. */
  function gmFormatTugrik(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '₮';
  }

  /* Cards advertise a round number. Always up, never down: a card must not
     name a payment lower than the one the calculator will quote. */
  function gmRoundUpThousand(n) {
    return Math.ceil(n / 1000) * 1000;
  }

  /* "1.98 сая-с/сар" — the same figure for a card too narrow for the full one.
     Two decimals, trailing zeros dropped, and the ₮ left off because the price
     directly above it already carries one. */
  function gmFormatMillions(n) {
    var m = (Math.round(n / 10000) / 100).toFixed(2).replace(/\.?0+$/, '');
    return m + ' сая-с/сар';
  }

  /**
   * Fills every [data-gm-monthly] in `root` from its own data attributes.
   * Cards whose car has no price are left alone by the Liquid that renders
   * them, so there is nothing to hide here.
   */
  function gmRenderMonthly(root) {
    (root || document).querySelectorAll('[data-gm-monthly]').forEach(function (el) {
      var priceMajor = parseInt(el.getAttribute('data-gm-monthly-price'), 10);
      var q = gmLeasingQuote(priceMajor, {
        downPct: parseFloat(el.getAttribute('data-gm-monthly-down')),
        rateTenths: parseFloat(el.getAttribute('data-gm-monthly-rate')),
        term: parseInt(el.getAttribute('data-gm-monthly-term'), 10) || 0
      });

      var out = el.querySelector('[data-gm-monthly-value]');
      var short = el.querySelector('[data-gm-monthly-short]');
      if (!q || !out) {
        /* Nothing trustworthy to show: drop the whole row rather than
           leave a label with an empty figure beside it. */
        el.hidden = true;
        return;
      }

      var rounded = gmRoundUpThousand(q.monthly);
      out.textContent = gmFormatTugrik(rounded);
      if (short) short.textContent = gmFormatMillions(rounded);
      el.hidden = false;
    });
  }

  window.gmLeasingQuote = gmLeasingQuote;
  window.gmFormatTugrik = gmFormatTugrik;
  window.gmFormatMillions = gmFormatMillions;
  window.gmRoundUpThousand = gmRoundUpThousand;
  window.gmRenderMonthly = gmRenderMonthly;
})();
